/*  eslint-disable react-hooks/exhaustive-deps, no-useless-escape, no-useless-computed-key  */
import React, { useState, useEffect } from 'react'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import back from '../assets/images/back.svg'
import { status } from '../_common/utils'
import { InputTextarea } from 'primereact/inputtextarea'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router'
import { userValidation } from '../_validation'
import { userActions } from '../_actions'

function AddUserComponent({ addUser, updateUser, userEntry, roleList }) {
  const [errors, setErrors] = useState({})
  const { id } = useParams()
  const history = useHistory()

  const [user, setUser] = useState({
    'firstName': '',
    'lastName': '',
    'emailAddress': '',
    'isActive': true,
    'state': '',
    'address': '',
    'armyBlue': '',
    'roleId': 2
  })

  useEffect(() => {
    if (userEntry) {
      setUser(
        {

          'firstName': userEntry != null ? userEntry.firstName : '',
          'lastName': userEntry != null ? userEntry.lastName : '',
          'emailAddress': userEntry != null ? userEntry.emailAddress : '',
          'isActive': userEntry != null ? userEntry.isActive:false,
          'userId': userEntry != null ? userEntry.userId : null,
          'createdOn': userEntry != null ? userEntry.createdOn : null,
          'createdBy': userEntry.createdBy ? userEntry.createdBy : '',
          'updatedBy': userActions.getCurrentUser(),
          'state': userEntry != null ? userEntry.state : '',
          'address': userEntry != null ? userEntry.address : '',
          'roleId': userEntry.role ? userEntry.role.roleId : '',
        })
    }
    if (!userEntry) {
      setUser({
        'firstName': '',
        'lastName': '',
        'emailAddress': '',
        'state': '',
        'address': '',
        'armyBlue': '',
        'roleId': 2,
        'isActive': true,
        'createdBy': userActions.getCurrentUser()
      }
      )
    }
  }, [userEntry])
  
 /* useEffect(() => {
    if (roleList)
      setUser(user => ({ ...user, ['roleId']: userEntry?.role?.roleId }))

  }, [roleList])*/

  const saveUser = (e) => {
    setErrors(userValidation.mandatory(user))
    e.preventDefault()
    if (user.firstName !== '' && user.lastName !== '' && user.emailAddress !== '' && !id && user.roleId > 0) {
      
      if (user.roleId > 0)
        user.role = { roleId: user.roleId }

      addUser(user)
    }

    if (user.firstName !== '' && user.lastName !== '' && user.emailAddress !== '' && id && user.roleId > 0) {
      
      if (user.roleId > 0)
        user.role = { roleId: user.roleId }
      updateUser(user, id)
    }
  }
  function onChange(e) {
    const { name, value } = e.target
    setUser(user => ({ ...user, [name]: value }))
  }

  const redirectBackToPreviousPage = () => {
    history.goBack()
  }

  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="p-grid">
            <div className="p-col-12 titleSec">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
              <h4 className="display_1 m-b-0">{id ? 'Edit' : 'Add'} User</h4>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">First Name <sup className="inputHolder--required">*</sup></label>
                <InputText name="firstName" className="inputHolder--inputBox" placeholder="First Name" value={user['firstName'] || ''} type="text" onChange={onChange} maxLength="256" />
                {errors.firstName && (
                  <p className='space-danger'>{errors.firstName}</p>
                )}
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Last Name <sup className="inputHolder--required">*</sup></label>
                <InputText name="lastName" className="inputHolder--inputBox" placeholder="Last Name" value={user?.lastName ? user?.lastName : ''} onChange={onChange} maxLength="256" />
                {errors.lastName && (
                  <p className='space-danger'>{errors.lastName}</p>
                )}
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Email Address <sup className="inputHolder--required">*</sup></label>
                <InputText name="emailAddress" className="inputHolder--inputBox" disabled={id ? true : false} placeholder="Email Address" value={user?.emailAddress ? user?.emailAddress : ''} onChange={onChange} maxLength="312" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" />
                {errors.emailAddress && (
                  <p className='space-danger'>{errors.emailAddress}</p>
                )}
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Status </label>
                <Dropdown options={status} name="isActive" className="inputHolder--dropdownBox" placeholder="Status" value={user?.isActive ? user?.isActive : false} onChange={onChange} />
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">State </label>
                <InputText name="state" className="inputHolder--inputBox" placeholder="State" value={user?.state ? user?.state : ''} onChange={onChange} maxLength="50" />
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Role <sup className="inputHolder--required">*</sup></label>
                <Dropdown name="roleId" dataKey="roleId" optionLabel="name" optionValue="roleId" options={roleList} className="inputHolder--dropdownBox" value={user?.roleId ? user?.roleId : 2} onChange={onChange} editable={false} placeholder="[Select Role]" />
                {errors.role && (
                  <p className='space-danger'>{errors.role}</p>
                )}
              </span></div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Address </label>
                <InputTextarea rows={5} cols={30} name="address" value={user?.address ? user?.address : ''} onChange={onChange} placeholder="Address" maxLength="256" />
              </span>
            </div>
            <div className="p-col-12 m-t-10">
              <Button label="Save" onClick={(event) => saveUser(event)} className="p-button-raised p-button-rounded inputHolder--formBtn" />
            </div>
          </div>
        </Card>
      </div>

    </div>
  )
}
AddUserComponent.propTypes = {
  addUser: PropTypes.func,
  roleList: PropTypes.array,
  userEntry: PropTypes.object,
  updateUser: PropTypes.func,
  addUserMessage: PropTypes.string,
}
export default AddUserComponent

